// extracted by mini-css-extract-plugin
module.exports = {"ActionButtons":"ActionButtons_ActionButtons__jhU3J","ResetButton":"ActionButtons_ResetButton__2F5cT","ResultButton":"ActionButtons_ResultButton__3Py_e"};